module.exports = __webpack_public_path__ + "img/close-icon-red.4244de77.svg";